<template>
  <!-- EXAMPLE USAGE:
  <BaseDropDown>
    <template v-slot:button>
      <div class="items-center flex">
        <span
          class="bg-gray-200 p-2 border border-solid hover:border-gray-300 mr-5 text-gray-400 hover:text-gray-500 hover:bg-gray-100 inline-flex items-center justify-center rounded-full"
        >
          <svg-icon icon="heroicons/outline/dots-horizontal"></svg-icon>
        </span>
      </div>
    </template>

    <template v-slot:body>
      <div class="text-sm font-semibold py-2 px-4">Insert Username</div>
      <div class="border border-solid border-gray-200"></div>
    </template>
  </BaseDropDown>
-->

  <!-- Uses clickaway mixin from https://github.com/simplesmiler/vue-clickaway -->
  <div v-on-clickaway="closePopover">
    <!-- Default Dropdown button -->
    <div
      class="cursor-pointer"
      v-on:click="togglePopover($event)"
      ref="popoverButton"
    >
      <slot name="button">
        <div class="items-center flex">
          <span
            class="w-8 h-8 text-sm hover:bg-gray-100 inline-flex items-center justify-center rounded-full"
          >
            <svg-icon
              icon="heroicons/outline/dots-vertical"
              class="h-6 w-6 text-gray-400 hover:text-gray-500"
            ></svg-icon>
          </span>
        </div>
      </slot>
    </div>

    <!-- START POPOVER PANEL -->

    <div ref="popover">
      <!-- START BODY -->
      <transition :name="transition">
        <slot v-if="visible" name="body"></slot>
      </transition>
    </div>
  </div>
</template>
<script>
//import Popper from "popper.js";
import { createPopper } from "@popperjs/core";
import { mixin as clickaway } from "vue-clickaway";
//import tippy from "tippy.js";

export default {
  components: {},
  mixins: [clickaway],
  data() {
    return {
      visible: false,
      popper: null,
      canClose: true,
    };
  },
  props: {
    placement: {
      type: String,
      required: false,
      default: "bottom-end",
    },

    //whether the popover is able to be displayed
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    
    //sort of a hack to allow triggering a close event from outside the component
    showPopover: {
      type: Boolean,
      required: false,
      default: false,
    },
    
    transition: {
      type: String,
      required: false,
      default: "pop-fade",
    },
  },
  methods: {
    togglePopover(event) {
      //console.log("toggle started: " + this.visible);
      event.preventDefault();
      if (this.visible) {
        this.closePopover();
      } else {
        this.openPopover();
        /*
        this.popper = createPopper(this.$refs.popoverButton, this.$refs.popover, {
            placement: this.placement,
          });
        
          this.popper = new Popper(this.$refs.popoverButton, this.$refs.popover, {
              placement: this.placement,
            });
            */
        //console.log("pop opened");
      }
    },
    openPopover: function() {
      if (!this.disabled) this.visible = true;
    },
    closePopover: function() {
      this.visible = false;
      //this.popper.destroy();
    },
    escapeKeyListener: function(evt) {
      if (evt.keyCode === 27 && this.visible) {
        this.visible = false;
      }
    },
  },
  watch: {
    
    showPopover() {
      //console.log('oi');
      if (this.showPopover == false) {
        this.visible = false;
      }
    },
    
    visible() {
      if (this.visible == true) {
        this.popper = createPopper(
          this.$refs.popoverButton,
          this.$refs.popover,
          {
            placement: this.placement,
          }
        );
      }
    },
  },
  created: function() {
    document.addEventListener("keyup", this.escapeKeyListener);
  },
  beforeDestroy(){
    if (this.popper){
      this.popper.destroy();
    }
  },
  destroyed: function() {
    document.removeEventListener("keyup", this.escapeKeyListener);
  },
};
</script>

<style>
.pop-fade-enter-active,
.pop-fade-leave-active {
  transition: opacity 0.1s ease-out;
}
.pop-fade-enter, .pop-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  /*transform: scale(0.5); */
}
.grow-enter-active,
.grow-leave-active {
  transition: all 0.2s ease-out;
}
.grow-enter, .grow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  transform: scale(0.5);
}
</style>
